import { render, staticRenderFns } from "./patientReport.vue?vue&type=template&id=1724c27a"
import script from "./patientReport.vue?vue&type=script&lang=js"
export * from "./patientReport.vue?vue&type=script&lang=js"
import style0 from "./patientReport.vue?vue&type=style&index=0&id=1724c27a&prod&lang=css"
import style1 from "./patientReport.vue?vue&type=style&index=1&id=1724c27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports